import React from "react";

/**
 * Profitink brand mark — a fountain-pen ink nib on a bordered square.
 * The nib references old-world ledger craft; the border echoes the design system.
 *
 * Props:
 *   size    – px height of the square mark (default 36)
 *   tone    – "gold" (dark surfaces) | "ink" (light surfaces)
 *   showWordmark – render "Profitink" wordmark next to the mark
 *   wordmarkClassName – tailwind classes for the wordmark span
 */
const Logo = ({ size = 36, tone = "gold", showWordmark = true, wordmarkClassName = "" }) => {
  const isGold = tone === "gold";
  const stroke = isGold ? "#D4AF37" : "#0F2E22";
  const fill = isGold ? "#D4AF37" : "#0F2E22";
  const bg = isGold ? "transparent" : "transparent";

  return (
    <span className="inline-flex items-center gap-2.5 select-none">
      <span
        aria-hidden="true"
        style={{ width: size, height: size, borderColor: stroke, background: bg }}
        className="inline-flex items-center justify-center border shrink-0"
      >
        <svg
          viewBox="0 0 32 32"
          width={size * 0.62}
          height={size * 0.62}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          {/* nib body (triangle) */}
          <path
            d="M16 3.5 L26 24 L16 21 L6 24 Z"
            fill={fill}
            fillOpacity="0.14"
            stroke={stroke}
            strokeWidth="1.4"
            strokeLinejoin="round"
          />
          {/* slit down the middle */}
          <path
            d="M16 8 L16 21"
            stroke={stroke}
            strokeWidth="1.3"
            strokeLinecap="round"
          />
          {/* breather hole */}
          <circle cx="16" cy="14" r="1.4" fill={stroke} />
          {/* ink drop underneath */}
          <path
            d="M16 25.5 C 17.6 27, 18.5 28.4, 18.5 29.2 C 18.5 30.35, 17.5 31, 16 31 C 14.5 31, 13.5 30.35, 13.5 29.2 C 13.5 28.4, 14.4 27, 16 25.5 Z"
            fill={fill}
          />
        </svg>
      </span>
      {showWordmark && (
        <span
          className={`font-serif-display tracking-tight ${wordmarkClassName}`}
          style={{ letterSpacing: "-0.01em" }}
        >
          Profit<span className="italic" style={{ color: stroke }}>ink</span>
        </span>
      )}
    </span>
  );
};

export default Logo;
